import { render, staticRenderFns } from "./commentList.vue?vue&type=template&id=57cc07ad&"
import script from "./commentList.vue?vue&type=script&lang=js&"
export * from "./commentList.vue?vue&type=script&lang=js&"
import style0 from "./commentList.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("D:\\work\\admin\\yujian_admin\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('57cc07ad')) {
      api.createRecord('57cc07ad', component.options)
    } else {
      api.reload('57cc07ad', component.options)
    }
    module.hot.accept("./commentList.vue?vue&type=template&id=57cc07ad&", function () {
      api.rerender('57cc07ad', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/indexDisposition/commentList.vue"
export default component.exports